var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth-button-component"},[_c('button',{staticClass:"btn",class:{ alternative: _vm.alternative },attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"button-background"}),_c('loading',{attrs:{"show":_vm.loading}},[_c('span',[_vm._v(_vm._s(_vm.text))])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }